import { serverFetch } from "@core/server";

export function fetchSprNumberSprList(vid) {
  return serverFetch("sprs/number-spr", {
    queryParams: { vid }
  });
}

export function fetchSprNumberSpr(vid, id) {
  return serverFetch(`sprs/number-spr/${vid}/${id}`);
}

export function createSprNumberSpr(bodyData) {
  return serverFetch("sprs/number-spr", {
    method: "POST",
    bodyData
  });
}

export function saveSprNumberSpr(bodyData) {
  return serverFetch("sprs/number-spr", {
    method: "PUT",
    bodyData
  });
}

export function deleteSprNumberSpr(vid, id) {
  return serverFetch(`sprs/number-spr/${vid}/${id}`, {
    method: "DELETE"
  });
}
